<div class="container-fluid" [ngClass]="{'p-0': mobileMode, 'h-100': mobileMode}" style="position: relative"
  [style.background-color]="clozeTestStyleModel.siteBackground">
  <div class="d-flex justify-content-center" [ngClass]="{'h-100': mobileMode}">
    <div class="card" [ngClass]="{'container-fluid': mobileMode, 'p-0': mobileMode}" style="min-height: 570px;"
      [style.background-color]="clozeTestStyleModel.exerciseBackground"
      [ngStyle]="{'border': mobileMode ? '0px' : '1px solid ' + clozeTestStyleModel.frameColor, 'border-radius': mobileMode? '0px' : '0.25rem', 'width': mobileMode? '' : '720px'}">
      <!-- mobile exercise indicator start -->
      <ng-container *ngIf="mobileMode">
        <gast-cloze-test-exercise-indicator [totalExercise]="totalExercise" [cTestLogo]="cTestLogo"
          [displayLogo]="clozeTestStyleModel.displayLogo" [currentExcerciseNumber]="currentExcerciseNumber">
        </gast-cloze-test-exercise-indicator>
      </ng-container>
      <!-- mobile exercise indicator end -->
      <div class="card-body" [style.font-family]="clozeTestStyleModel.font"
        [style.font-size]="clozeTestStyleModel.fontSize">
        <img *ngIf="clozeTestStyleModel.displayLogo && !mobileMode" class="floating-logo" [src]="cTestLogo">
        <br><br>
        <div *ngIf="showResult">
          <ng-container *ngIf="!mobileMode">
            <p class="card-text">{{ 'GAST-ONSET-NG.TEST_RESULT.TEST_ENDED_1' | translate }}<br><br>{{results.score}}
              {{ 'GAST-ONSET-NG.TEST_RESULT.POINTS' | translate }}
              <br><br>{{ 'GAST-ONSET-NG.TEST_RESULT.TEST_ENDED_2' | translate }}
              {{results.score/results.maxScore | percent: '2.0-2'}}
              {{ 'GAST-ONSET-NG.TEST_RESULT.TEST_ENDED_3' | translate }}
              {{results.maxScore}} {{ 'GAST-ONSET-NG.TEST_RESULT.POINTS' | translate }}</p>
            <p class="card-text">
              {{ 'GAST-ONSET-NG.TEST_RESULT.LEVEL_TEXT' | translate }}<br><br>
              <b>{{results.graduation}}</b><br><br>
            </p>
            <p class="card-text">
              <a
                [href]="clozeTestStyleModel.cTestInformationUrl">{{ 'GAST-ONSET-NG.TEST_RESULT.MORE_INFO' | translate }}</a>
            </p>
          </ng-container>
          <ng-container *ngIf="mobileMode">
            <p class="card-text">{{ 'GAST-ONSET-NG.MOBILE.TEST_RESULT.DONE' | translate }}</p>
            <p class="card-text">
              {{ 'GAST-ONSET-NG.MOBILE.TEST_RESULT.YOUR_SCORE' | translate: {score:results.score, maxScore: results.maxScore} }}
            </p>
            <p class="card-text">
              {{ 'GAST-ONSET-NG.MOBILE.TEST_RESULT.YOUR_LEVEL' | translate: {level:results.graduation} }}</p>
          </ng-container>
        </div>
        <div *ngIf="!showResult">
          {{ 'GAST-ONSET-NG.MOBILE.TEST_RESULT.TEST_IS_DONE' | translate }}
        </div>
        <div class="text-center" style="margin-top: 30px;">
          <ng-container *ngIf="mobileMode">
            <button class="btn" style="font-size: smaller;margin-right: 10px;"
              [style.background-color]="cTestButtonColor" (click)="onGerInfoClick()">
              {{ 'GAST-ONSET-NG.MOBILE.TEST_RESULT.WHAT_IS_GER' | translate }}
            </button>
          </ng-container>
          <div *ngIf="showEndTestButton">
            <button class="btn" style="font-size: smaller;" [style.background-color]="cTestButtonColor"
              (click)="onClozeTest()">
              {{ 'GAST-ONSET-NG.MOBILE.TEST_RESULT.END_TEST' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
